// Import polyfills FIRST before any other imports
// This ensures Buffer and other Node.js polyfills are available
import "./polyfills";
import { ShogunCore } from "./core";
import { RxJS, crypto, derive, GunErrors, DataBase } from "./gundb/db";
import { DataBaseHolster } from "./gundb/db-holster";
import { RxJSHolster } from "./gundb/rxjs-holster";
// Gun and SEA imports removed - users should import them directly from 'gun' package
// This prevents bundling issues in build systems like Vite
export * from "./utils/errorHandler";
export * from "./plugins";
export * from "./interfaces/shogun";
export * from "./gundb/gun-es";
export { ShogunCore, RxJS, crypto, derive, GunErrors, DataBase, DataBaseHolster, RxJSHolster, };
// Note: Gun and SEA are not exported to avoid bundling issues
// Users should import Gun and SEA directly from the 'gun' package
// Export seed phrase utilities for WebAuthn multi-device support
export { generateSeedPhrase, validateSeedPhrase, mnemonicToSeed, seedToPassword, deriveCredentialsFromMnemonic, formatSeedPhrase, normalizeSeedPhrase, } from "./utils/seedPhrase";
// Export storage
export { ShogunStorage } from "./storage/storage";
// Export polyfill utilities
export { setBufferPolyfill } from "./polyfills";
